var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgQuestion(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 7,
    cy: 7,
    r: 5.625,
    stroke: "#fff",
    strokeWidth: 0.75
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.504 8.398c.005-.31.04-.554.105-.734.065-.18.198-.379.399-.598l.512-.527c.218-.247.328-.513.328-.797 0-.273-.072-.487-.215-.64-.143-.157-.352-.235-.625-.235-.266 0-.48.07-.64.211a.713.713 0 00-.243.567h-.723c.006-.422.155-.762.45-1.02.296-.26.682-.39 1.156-.39.492 0 .875.132 1.148.398.276.263.414.625.414 1.086 0 .455-.21.905-.633 1.347l-.425.422c-.19.211-.285.515-.285.91h-.723zm-.031 1.239c0-.117.035-.215.105-.293.073-.081.18-.121.32-.121.141 0 .248.04.32.12.074.079.11.177.11.294a.413.413 0 01-.11.293c-.072.075-.179.113-.32.113-.14 0-.247-.038-.32-.113a.422.422 0 01-.105-.293z",
    fill: "#fff"
  })));
}
SvgQuestion.displayName = 'Question';
export default SvgQuestion;